
import {Component, Prop, Vue} from "vue-property-decorator";
import {listMark, listMarkType, queryMarkByBrandsAndCustomer} from "@/api/mark-management";
import {batchAssignMark, queryBrands} from "@/api/purchase-order";
import {getAssignMarkInfo} from "@/api/proforma";
import {deepClone} from "@/utils/deepClone";

@Component({name: "assignMarks"})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "批量指定唛头" }) private title: "";
  @Prop({ default: "" }) private id: "";
  @Prop({ default: "" }) private customerId: string;

  public tableCol = [
    {
      label: "采购订单",
      prop: "purchaseOrderCode",
      key: "purchaseOrderCode",
      show: true,
      disabled: false
    },
    {
      label: "品牌",
      prop: "brand",
      key: "brand",
      show: true,
      disabled: false
    },
    {
      label: "供应商",
      prop: "supplier",
      key: "supplier",
      show: true,
      disabled: false
    },
    {
      label: "产品品名",
      prop: "productName",
      key: "productName",
      show: true,
      disabled: false
    },
    {
      label: "箱唛",
      prop: "ctnMark",
      key: "ctnMark",
      show: true,
      header: true,
      disabled: false
    },
    {
      label: "托唛",
      prop: "pltMark",
      key: "pltMark",
      show: true,
      disabled: false
    },
    {
      label: "额外唛头",
      prop: "otherMark",
      key: "otherMark",
      show: true,
      disabled: false
    },
    {
      label: "替代唛头字母",
      prop: "markLetterReplace",
      key: "markLetterReplace",
      icon: "el-icon-edit",
      type: "icon_edit",
      click: "handleMarkLetterReplace",
      show: true,
      disabled: false
    },
    {
      label: "自编号",
      prop: "selfCode",
      key: "selfCode",
      show: true,
      disabled: false
    },
    {
      label: "显示英文品名",
      prop: "specialMarks",
      key: "specialMarks",
      type: "checkbox",
      show: true,
      disabled: false
    }
  ] as any;

  private tableList = [];

  private brandOption = [];
  private markType = [];
  private marks = [];
  private listParams = {
    customerId: null,
    brandId: null,
    markType: null
  }
  private currentMark = "";
  private multipleSelection: any[] = [];
  private currentRow: any = {};

  created() {
    this.getMarkType();
  }

  private async getMarkType() {
    this.markType = await listMarkType() as any;
  }

  private async open() {
    this.brandOption = await queryBrands({proformaInvoiceId: this.id}) as any;
    this.tableList = await getAssignMarkInfo(this.id) as any;
  }

  private close() {
    const multipleTable = this.$refs.multipleTable as any;
    const table = multipleTable.$refs.table as any;
    table.clearSelection();
    this.multipleSelection = [];
    this.$emit("update:show", false);
  }

  private async queryMark() {
    this.currentMark = "";
    if (this.listParams.brandId && this.listParams.markType) {
      this.listParams.customerId = this.customerId;
      this.marks = await listMark(this.listParams) as any;
    }else {
      this.marks = [];
    }
  }

  private onSelectionChange(rows: any[]) {
    this.multipleSelection = rows;
  }

  private addMark() {
    if (this.multipleSelection.length === 0) {
      this.$message.error("请选择数据之后再添加");
      return;
    }
    const current = this.marks.find(item => item.id === this.currentMark);
    if (!current) {
      this.$message.error("请选择唛头之后再添加");
      return;
    }
    const brand = this.brandOption.find(item => item.id === this.listParams.brandId);
    const filterSelect = this.multipleSelection
        .filter(item => item.brand === brand.name)
        .map(item => item.purchaseOrderId);
    this.tableList.forEach(item => {
      if (filterSelect.includes(item.purchaseOrderId)) {
        if (this.listParams.markType === 'CTN_MARK') {
          item.ctnMark = current.name;
          item.ctnMarkId = current.id;
        }
        if (this.listParams.markType === 'PLT_MARK') {
          item.pltMark = current.name;
          item.pltMarkId = current.id;
        }
        if (this.listParams.markType === 'OTHER_MARK') {
          item.otherMark = current.name;
          item.otherMarkId = current.id;
        }
      }
    });
    this.tableList = deepClone(this.tableList);
  }

  private deleteMark() {
    if (this.multipleSelection.length === 0) {
      this.$message.error("请选择要清空的数据");
      return;
    }
    const poIds = this.multipleSelection.map(item => item.purchaseOrderId);
    this.tableList.forEach(item => {
      if (poIds.includes(item.purchaseOrderId)) {
        item.ctnMark = null;
        item.ctnMarkId = null;
        item.pltMark = null;
        item.pltMarkId = null;
        item.otherMark = null;
        item.otherMarkId = null;
        item.markLetterReplace = null;
      }
    });
  }

  private async reSet() {
    this.tableList = await getAssignMarkInfo(this.id) as any;
  }

  private async submitForm() {
    const data: any[] = [];
    this.tableList.forEach(x => {
      const params: any = {};
      params.purchaseOrderId = x.purchaseOrderId;
      params.ctnMarkId = x.ctnMarkId;
      params.pltMarkId = x.pltMarkId;
      params.otherMarkId = x.otherMarkId;
      params.markLetterReplace = x.markLetterReplace;
      params.specialMarks = x.specialMarks;
      data.push(params);
    });
    await batchAssignMark({req: data})
        .then(() => {
          const multipleTable = this.$refs.multipleTable as any;
          const table = multipleTable.$refs.table as any;
          table.clearSelection();
          this.multipleSelection = [];

          this.$notify({
            title: "成功",
            message: "操作成功",
            type: "success",
            duration: 2000
          });
          this.$emit("success");
        })
        .catch(error => console.log(error));
  }

  private asyncMarkLetterReplace = false;
  private markLetterReplace = "";
  private handleMarkLetterReplace(scope) {
    this.currentRow = scope.row;
    if(scope.row.markLetterReplace) {
      this.markLetterReplace = scope.row.markLetterReplace;
    }
    this.asyncMarkLetterReplace = true;
  }

  private changeMarkLetterReplace() {
    this.currentRow.markLetterReplace = this.markLetterReplace;
    this.tableList = deepClone(this.tableList);
    this.markLetterReplace = "";
    this.asyncMarkLetterReplace = false;
  }

  private async insertWithBrand() {
    if (this.multipleSelection.length === 0) {
      this.$message.error("请选择数据之后再添加");
      return;
    }
    const brands = this.multipleSelection.map(item => item.brand);
    const params = {customerId: this.customerId, brands: brands}
    const res = await queryMarkByBrandsAndCustomer(params) as any;
    res.forEach(item => {
      const list = this.multipleSelection.filter(tVal => tVal.brand === item.brand);
      list.forEach(x => {
        if (item.markType === 'CTN_MARK') {
          x.ctnMark = item.name;
          x.ctnMarkId = item.id;
        }
        if (item.markType === 'PLT_MARK') {
          x.pltMark = item.name;
          x.pltMarkId = item.id;
        }
        if (item.markType === 'OTHER_MARK') {
          x.otherMark = item.name;
          x.otherMarkId = item.id;
        }
      });
    });
    this.tableList = deepClone(this.tableList);
    console.log(this.tableList);
  }
}
